export enum MediaContentType {
    Image = 'image',
    Video = 'video',
}

export interface MediaContent {
    url: string;
    type: MediaContentType;
}
